import defaultItems from '../../../../../common/defaultItems';

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Table',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 10,
            paddingBottom: 10,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'TABLE',
                            content: {
                                ...defaultItems.TABLE.content,
                                align: 'center',
                            },
                        },
                    ],
                },
            ],
        },
    };
}
